import compact from './data/region-tag-labels.compact.json';

/**
 * Decodes data/region-tag-labels.compact.json, the copy of data/region-tag-labels.json that
 * scripts/generate-region-tag-labels.ts also writes in a compact form because it ships to every
 * page: one array per placeId, `[en, fi | 0, sv | 0, typeIndex, countryCode?]`, where 0 means
 * "same as en". That is ~42 KB instead of ~100 KB of repeated objects. The full JSON stays the
 * canonical file for everything else (scripts, tests, the mobile app's hand-copied version), and a
 * test keeps the two identical once decoded.
 */
export type RegionTagType = 'continent' | 'recruitingRegion' | 'country' | 'admin1' | 'city';

export interface RegionTagLabelEntry {
  en: string;
  fi: string;
  sv: string;
  type: RegionTagType;
  /** Country entries only: ISO 3166-1 alpha-2 (see getRegionTagValueForCountryCode). */
  countryCode?: string;
}

type CompactRow = [string, string | 0, string | 0, number] | [string, string | 0, string | 0, number, string];

// Through unknown: the JSON's inferred tuple types are wider than CompactRow.
const { types, rows } = compact as unknown as { types: RegionTagType[]; rows: Record<string, CompactRow> };

export const REGION_TAG_LABELS: Record<string, RegionTagLabelEntry> = {};
for (const [placeId, [en, fi, sv, typeIndex, countryCode]] of Object.entries(rows)) {
  const entry: RegionTagLabelEntry = { en, fi: fi || en, sv: sv || en, type: types[typeIndex] };
  if (countryCode) entry.countryCode = countryCode;
  REGION_TAG_LABELS[placeId] = entry;
}
